/** Known deployable app IDs (`NEXT_PUBLIC_APP_ID`). */
export const APP_IDS = ['uvilo-ai', 'forgentic'] as const;

export type AppId = (typeof APP_IDS)[number];

function isAppId(value: string): value is AppId {
  return (APP_IDS as ReadonlyArray<string>).includes(value);
}

/**
 * Returns the current app id from `NEXT_PUBLIC_APP_ID`.
 *
 * Validates against {@link APP_IDS}. Throws when unset or unknown — there is no
 * default.
 * @returns Current app id (e.g. for SettingValue scoping, Inngest client id, Execution.appId).
 * @throws When `NEXT_PUBLIC_APP_ID` is unset or not a known {@link AppId}.
 */
export function getCurrentAppId(): AppId {
  const appId = process.env.NEXT_PUBLIC_APP_ID;
  if (typeof appId !== 'string' || appId.length === 0) {
    throw new Error('NEXT_PUBLIC_APP_ID is required but was unset or empty');
  }
  if (!isAppId(appId)) {
    throw new Error(
      `NEXT_PUBLIC_APP_ID must be one of ${APP_IDS.join(', ')}; got ${JSON.stringify(appId)}`,
    );
  }
  return appId;
}
